export interface IconType {
  d: string;
  width: number;
  height: number;
  fillRule: CanvasFillRule;
}

export const LINK_ICON: IconType = {
  d: 'm 13.767577,0 h 3.441895 c 1.625339,0.047804 2.975786,0.609506 4.051339,1.6850903 1.075707,1.0755996 1.637424,2.4260614 1.685152,4.0514008 -0.04772,1.6253387 -0.609445,2.9757851 -1.685152,4.0513391 -1.075553,1.0757058 -2.426,1.6374238 -4.051339,1.6851508 h -3.441895 c -0.334705,0 -0.609445,-0.10754 -0.824677,-0.32262 -0.215081,-0.215233 -0.322621,-0.489973 -0.322621,-0.824678 0,-0.3347047 0.10754,-0.6094448 0.322621,-0.8246778 0.215232,-0.21508 0.489972,-0.32262 0.824677,-0.32262 h 3.441895 c 0.979946,-0.02386 1.792691,-0.358569 2.438085,-1.003809 C 20.292798,7.5291514 20.627503,6.7164665 20.651366,5.7364911 20.627503,4.7565147 20.292798,3.9438296 19.647557,3.2984821 19.002163,2.6531346 18.189418,2.3184907 17.209472,2.2945962 h -3.441895 c -0.334705,0 -0.609445,-0.1075553 -0.824677,-0.3226814 -0.215081,-0.2151107 -0.322621,-0.4899881 -0.322621,-0.8246167 0,-0.3346286 0.10754,-0.609506 0.322621,-0.8246167 C 13.158132,0.1075554 13.432872,0 13.767577,0 Z M 5.7364911,9.1783852 h 3.4418938 c 0.3347051,0 0.6094449,0.10754 0.8246781,0.32262 0.21508,0.215233 0.32262,0.4899731 0.32262,0.8246778 0,0.334705 -0.10754,0.609445 -0.32262,0.824678 -0.2152332,0.21508 -0.489973,0.32262 -0.8246781,0.32262 H 5.7364911 C 4.1111517,11.425254 2.7606899,10.863536 1.6850903,9.7878302 0.60950598,8.7122762 0.04780405,7.3618298 0,5.7364911 0.04780405,4.1111517 0.60950598,2.7606899 1.6850903,1.6850903 2.7606899,0.609506 4.1111517,0.047804 5.7364911,0 h 3.4418938 c 0.3347051,0 0.6094449,0.1075554 0.8246781,0.3226814 0.21508,0.2151107 0.32262,0.4899881 0.32262,0.8246167 0,0.3346286 -0.10754,0.609506 -0.32262,0.8246167 C 9.7878298,2.1870409 9.51309,2.2945962 9.1783849,2.2945962 H 5.7364911 C 4.7565145,2.3184907 3.9438296,2.6531346 3.2984821,3.2984821 2.6531346,3.9438296 2.3184907,4.7565147 2.2945963,5.7364911 c 0.023895,0.9799754 0.3585383,1.7926603 1.0038858,2.4380851 0.6453475,0.64524 1.4580324,0.979946 2.438009,1.003809 z M 7.2064706,6.5611076 C 6.991344,6.3459969 6.8837891,6.0711194 6.8837891,5.7364911 6.8837891,5.4018618 6.991344,5.1269844 7.2064706,4.9118737 7.4215813,4.6967479 7.6964579,4.5891925 8.0310871,4.5891925 h 6.8837879 c 0.334705,0 0.609445,0.1075554 0.824679,0.3226812 0.21508,0.2151107 0.322619,0.4899881 0.322619,0.8246174 0,0.3346283 -0.107539,0.6095058 -0.322619,0.8246165 C 15.52432,6.7762333 15.24958,6.8837893 14.914875,6.8837893 H 8.0310871 c -0.3346292,0 -0.6095058,-0.107556 -0.8246165,-0.3226817 z',
  width: 22.9459,
  height: 11.4729,
  fillRule: 'evenodd',
};

export const OPEN_RECORD: IconType = {
  d: 'M25.6 0.0996094H6.4C3.4 0.0996094 1.8 0.0996095 0.9 0.999609C0 1.99961 0 3.49961 0 6.59961V19.4996C0 22.4996 0 24.0996 0.9 24.9996C1.8 25.8996 3.4 25.8996 6.4 25.8996H25.5C27.8 25.8996 29.2 25.8996 30.2 25.4996C30.5 25.3996 30.8 25.1996 31 24.9996C32 23.9996 32 22.4996 32 19.3996V6.59961C32 3.59961 32 1.99961 31.1 1.09961C30.1 0.0996094 28.6 0.0996094 25.6 0.0996094ZM17 2.89961V23.1996H6.4C4.8 23.1996 3.9 23.1996 3.2 23.0996C3.1 22.9996 3 22.9996 2.9 22.9996C2.9 22.8996 2.9 22.7996 2.8 22.5996C2.7 21.9996 2.7 20.9996 2.7 19.3996V6.59961C2.7 4.99961 2.7 4.09961 2.8 3.39961C2.8 3.19961 2.8 3.09961 2.9 2.99961C3 2.99961 3.1 2.99961 3.3 2.99961C4 2.89961 4.9 2.89961 6.5 2.89961H17ZM24.9 7.19961C25.4 7.19961 25.8 6.79961 25.8 6.29961C25.8 5.79961 25.4 5.39961 24.9 5.39961H21.4C20.9 5.39961 20.5 5.79961 20.5 6.29961C20.5 6.79961 20.9 7.19961 21.4 7.19961H24.9ZM27.6 12.1996C28.1 12.1996 28.5 11.7996 28.5 11.2996C28.5 10.7996 28.1 10.3996 27.6 10.3996H21.4C20.9 10.3996 20.5 10.7996 20.5 11.2996C20.5 11.7996 20.9 12.1996 21.4 12.1996H27.6Z',
  width: 32,
  height: 26,
  fillRule: 'evenodd',
};

export const SLASH_SEPARATOR: IconType = {
  d: 'M0.225899 13.7042L6.81246 2.2959H8.77004L8.7741 2.29824L2.18889 13.7042H0.225899Z',
  width: 9,
  height: 16,
  fillRule: 'evenodd',
};

export const ANGLE_SEPARATOR: IconType = {
  d: 'M1.87354 13.705L5.16731 8.00006H5.16555L1.87106 2.29504H3.83447L7.12895 8.00006H7.12489L7.12895 8.00241L3.83653 13.705H1.87354Z',
  width: 9,
  height: 16,
  fillRule: 'evenodd',
};

interface RenderIconOptions {
  ctx: CanvasRenderingContext2D;
  icon: IconType;
  fillStyle: CanvasFillStrokeStyles['fillStyle'];
  opacity?: number;
  useFillRule?: boolean;
}

/*
 * Renders an icon loaded using one of fabric's loadSVG methods (e.g.
 * loadSVGFromString), whose size is independent of the shape's dimensions.
 *
 *
 * The position (x, y) can be passed into the function as scalar values or as
 * a function. In the latter case, the scaled dimensions of the icon will be
 * passed as arguments to the function.
 *
 * Returns an object containing the scaled dimensions of the rendered icon.
 * */
export function renderIcon(options: RenderIconOptions) {
  const { ctx, icon, fillStyle, opacity = 1, useFillRule = false } = options;
  const { d, fillRule: iconFillRule } = icon;

  ctx.save();
  let path;

  // @ts-expect-error createPath will exist when rendering to SVG or testing.
  if (ctx.createPath) {
    // @ts-expect-error createPath will exist when rendering to SVG or testing.
    path = ctx.createPath(d);
  } else {
    path = new Path2D(d);
  }

  if (fillStyle) {
    ctx.fillStyle = fillStyle;
  }
  ctx.globalAlpha = opacity;

  const fillRule = useFillRule ? iconFillRule : 'nonzero';
  ctx.fill(path, fillRule);
  ctx.restore();
}
